import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { FacebookService } from "src/app/services/social/facebook.service";
import { FeedLoadingService } from "src/app/services/social/feed-loading.service";

@Component({
  selector: "app-facebook-item",
  templateUrl: "./facebook-item.component.html",
  styleUrls: ["./facebook-item.component.css"],
})
export class FacebookItemComponent implements OnInit, OnDestroy {
  reactions = {
    like: "👍",
    love: "❤️",
    care: "😍",
    haha: "😆",
    wow: "😮",
    sad: "😢",
    angry: "😠",
  };
  @Input() post: any = {};

  loadingPostLink = false;
  loadingAction: 'reply' | 'view-reply' | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private facebookService: FacebookService,
    private toaster: ToastrService,
    private feedLoadingService: FeedLoadingService
  ) {}

  get isAnyLoading(): boolean {
    return this.loadingPostLink || this.loadingAction !== null || this.feedLoadingService.isLoadingValue;
  }

  ngOnInit() {
    this.facebookService.repliedPost.subscribe((id) => {
      if (id === this.post.post_id) {
        this.post.is_handled = true;
      }
    });

    this.facebookService.postModalReady$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.resetLoadingState());
  }

  getReaction(reaction: string) {
    return this.reactions[reaction];
  }

  onPostLinkClick(post: any) {
    if (this.isAnyLoading) return;
    this.loadingPostLink = true;
    this.feedLoadingService.setLoading();
    this.getPostDetails("view-reply", post, post.onItem);
  }

  onReplyClick(post: any) {
    if (this.isAnyLoading) return;
    this.loadingAction = 'reply';
    this.feedLoadingService.setLoading();
    this.getPostDetails("reply", post, post.itemId,
      post.itemId || post.facebookObject.id);
  }

  onViewReplyClick(post: any) {
    if (this.isAnyLoading) return;
    this.loadingAction = 'view-reply';
    this.feedLoadingService.setLoading();
    this.getPostDetails(
      'view-reply',
      post,
      post.itemId || post.facebookObject.id,
      post.replyId || post.facebookObject.id
    );
  }

  async getPostDetails(action: string, post: any, commentId: string, replyId?: string, replyParentCommentId?: string) {
    if (post.item === "mentions") {

      this.openPostModal(action, post);
      this.resetLoadingState();
      return;
    }

    this.facebookService.fetchFacebookPost(post.pageId, post.onItem).subscribe({
      next: (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
            this.openPostModal(action, { ...payload }, commentId, replyId, replyParentCommentId);
        } else {
          this.resetLoadingState();
        }
      },
      error: () => {
        this.toaster.error("Cannot find post.");
        this.resetLoadingState();
      }
    });
  }

  openPostModal(action: string, post: object, commentId?: string, replyId?: string, parentCommentId?: string) {
    this.facebookService.postToView.next({action, post, commentId, replyId, parentCommentId });
  }

  openReplyModal(post: object) {
    this.facebookService.postToReply.next(post);
  }

  private resetLoadingState() {
    this.loadingPostLink = false;
    this.loadingAction = null;
    this.feedLoadingService.clearLoading();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.feedLoadingService.clearLoading();
  }
}
